export const SET_CART_DETAILS = 'SET_CART_DETAILS'
export const RESET_CART_DETAILS = 'RESET_CART_DETAILS'
export const SET_CART_DISCOUNT = 'SET_CART_DISCOUNT'
export const SET_MIX_MATCH_DISCOUNT = 'SET_MIX_MATCH_DISCOUNT'
export const SET_EXTRA_ITEMS = 'SET_EXTRA_ITEMS'
export const SET_EXTRA_DISCOUNT = 'SET_EXTRA_DISCOUNT'